import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=5edb1fd0&lang=pug&"
import script from "./x-icon.vue?vue&type=script&lang=js&"
export * from "./x-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports